import { useTranslations } from "next-intl";

import {
  type TRequestLoginCodeInputProps,
  type TRequestLoginCodeSubmitProps,
} from "./RequestLoginCode.config";
import {
  getRequestLoginCodeEmailProps,
  getRequestLoginCodeMessages,
  getRequestLoginCodeSubmitProps,
} from "./RequestLoginCode.utils";

export const useRequestLoginCode = (
  {
    email,
    submit,
  }: {
    email: TRequestLoginCodeInputProps;
    submit: TRequestLoginCodeSubmitProps;
  },
) => {
  const t = useTranslations("Libs.UI.Components.RequestLoginCode");
  const messages = getRequestLoginCodeMessages(t);
  const resolvedSubmit = getRequestLoginCodeSubmitProps(submit, messages);

  return {
    emailProps: getRequestLoginCodeEmailProps(email, messages),
    submitLabel: resolvedSubmit.label,
    submitProps: resolvedSubmit.props,
  };
};
